import { useEffect, useMemo, useRef } from 'react'

import { type Filters } from '..'
import { type Column, Table } from '../../../../components/Table'
import { useInfiniteScroll } from '../../../../hooks/useInfiniteScroll'
import { useInfiniteExpertsQuery } from '../../../../services/hooks/experts/queries/useExpertQuery'
import { type ExpertDomain } from '../../../../types/domain/expert-domain'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { mapExpertDomainDataToTableRow } from '../utils/mapExpertDomainDataToTableRow'

type Props = {
  columns: Column[]
  filters: Filters
  showExpertBioButton?: boolean
}

export const ViewExpertsWithInfiniteScroll = ({
  columns,
  filters,
  showExpertBioButton = false,
}: Props) => {
  const tableContainerRef = useRef(null)

  const {
    data,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  } = useInfiniteExpertsQuery({
    ...filters,
    take: 20,
  })

  const rows = useMemo(() => {
    const pages = data?.pages

    return pages
      ?.reduce(
        (acc: ExpertDomain[], { data }: PaginationDomain<ExpertDomain>) => {
          return [...acc, ...data]
        },
        []
      )
      .map(mapExpertDomainDataToTableRow)
  }, [data])

  useInfiniteScroll(tableContainerRef, hasNextPage, fetchNextPage)

  useEffect(() => {
    refetch()
  }, [])

  return (
    <Table
      columns={columns}
      rows={rows || []}
      isLoading={isLoading}
      tableContainerRef={tableContainerRef}
      paginationMode="scroll"
      compactListingFont
      isFetchingNextPage={isFetchingNextPage}
      noContentMessage="Sem registro de usuário(s)"
      onRowClick={(id) =>
        window.open(`/painel/database/${id}`, '_blank', 'noopener,noreferrer')
      }
      showExpertBioButton={showExpertBioButton}
    />
  )
}
